import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Box from './Box';
import Code from './Code';
import Wrapper from './Wrapper';

function TranslateCalcDemo({ variant, pixels, percentage }) {
  const transform = `translateX(calc(${percentage}% + ${pixels}px))`;

  const styles = useSpring({
    transform,
  });

  return (
    <Wrapper>
      <Box style={styles} />
      <Code>transform: {transform};</Code>
    </Wrapper>
  );
}

const BoxRow = styled.div`
  display: flex;
  gap: 16px;
`;

export default TranslateCalcDemo;
